var map = {
	"./death_knight.jpg": 517,
	"./demon_hunter.jpg": 256,
	"./druid.jpg": 257,
	"./evoker.jpg": 518,
	"./hunter.jpg": 519,
	"./mage.jpg": 520,
	"./monk.jpg": 521,
	"./paladin.jpg": 308,
	"./priest.jpg": 522,
	"./rogue.jpg": 523,
	"./shaman.jpg": 524,
	"./warlock.jpg": 525,
	"./warrior.jpg": 526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1099;